"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import useIsClient from "@/hooks/useIsClient";
import useShouldFire from "./useShouldFire";
export default function useFacebookPixel(
  pixel_id?: string | number,
  refresh?: boolean,
) {
  const pathname = usePathname();
  const client = useIsClient();
  const shouldFire = useShouldFire();
  useEffect(() => {
    if (!pixel_id || !client || !shouldFire) return;
    if (pathname) {
      let ReactPixel: any;
      import("react-facebook-pixel")
        .then((module) => (ReactPixel = module.default))
        .then(() => {
          ReactPixel.init(pixel_id, {
            autoConfig: true,
          });
          ReactPixel.pageView();
        });
    }
  }, [pathname, client, pixel_id, refresh, shouldFire]);
  function trackEvent(event: any, data: any) {
    let ReactPixel: any;
    import("react-facebook-pixel")
      .then((module) => (ReactPixel = module.default))
      .then(() => {
        ReactPixel.track(event, { ...data });
      })
      .then(() => {
        if ((event as string).toLocaleLowerCase() === "purchase")
          fetch("/api/log-info", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              message: "facebook pixle Purchase event",
              details: {
                ...data,
              },
              host:
                typeof window !== "undefined"
                  ? window.location.hostname
                  : "server",
              url:
                typeof window !== "undefined" ? window.location.pathname : "",
            }),
          });
      });
  }

  return { trackEvent };
}
